var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49998 4.83334C5.32565 4.83334 4.33331 5.82568 4.33331 7.00001C4.33331 8.17434 5.32565 9.16668 6.49998 9.16668C7.67431 9.16668 8.66665 8.17434 8.66665 7.00001C8.66665 5.82568 7.67431 4.83334 6.49998 4.83334ZM6.49998 8.08334C5.9231 8.08334 5.41665 7.57689 5.41665 7.00001C5.41665 6.42314 5.9231 5.91668 6.49998 5.91668C7.07685 5.91668 7.58331 6.42314 7.58331 7.00001C7.58331 7.57689 7.07685 8.08334 6.49998 8.08334Z",
    fill: "#673C8E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 3.20834L9.43256 3.20834L7.96627 1.74205C7.86498 1.64022 7.7274 1.58334 7.58331 1.58334L5.41665 1.58334C5.27256 1.58334 5.13498 1.64022 5.03369 1.74205L3.5674 3.20834L2.16665 3.20834C1.56919 3.20834 1.08331 3.69422 1.08331 4.29168L1.08331 10.25C1.08331 10.8475 1.56919 11.3333 2.16665 11.3333L10.8333 11.3333C11.4308 11.3333 11.9166 10.8475 11.9166 10.25L11.9166 4.29168C11.9166 3.69422 11.4308 3.20834 10.8333 3.20834ZM2.16665 10.25L2.16665 4.29168H3.79165C3.93573 4.29168 4.07331 4.2348 4.1746 4.13297L5.6409 2.66668L7.35906 2.66668L8.82535 4.13297C8.92665 4.2348 9.06423 4.29168 9.20831 4.29168H10.8333L10.8344 10.25L2.16665 10.25Z",
    fill: "#673C8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.f24d284d3a4ec5f028464c7275a499a2.svg";
export { ForwardRef as ReactComponent };